module.exports = __webpack_public_path__ + "img/gif.5879f695.png";